import { httpTokenCommon } from "../helper/http-common";

class GlobalServices {
  getPolicyData(country: string) {
    return httpTokenCommon.get(`Policy/getPolicyTypes/${country}`);
  }
  getPolicyDataById(id: number) {
    return httpTokenCommon.get(`Policy/getDocuments/${id}`);
  }
}

const globalServices = new GlobalServices();
export default globalServices;
